import { Component, Input } from '@angular/core';
import { Szme042aResponseDryrskInfDto } from 'sg-api';

/**
 * 延滞利息一覧
 * @export
 * @class OverdueInterestListComponent
 */

@Component({
  selector: 'app-overdue-interest-list',
  templateUrl: './overdue-interest-list.component.html',
  styleUrls: ['./overdue-interest-list.component.scss']
})
export class OverdueInterestListComponent {
  @Input() interestList: Szme042aResponseDryrskInfDto[];

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'pydlndStdday', // 検針年月日
    'dlineDate', // 支払期限日
    'dryrskClgrltDate', // 猶予期限日
    'rcvDate', // 領収日
    'rcvMny', // 領収金額
    'targetMny', // 対象料金
    'delayRisoku' // 延滞利息金額
  ];

  constructor() { }

}
